/**
 * Euro item
 * @param {*} editor
 */
function dollar(editor) {
  const cm = editor.codemirror;
  const output = '&dollar;';
  cm.replaceSelection(output);
}

export default function () {
  const option = {
    name: 'Dollar',
    action: dollar,
    className: 'fa fa-dollar',
    title: 'Dollar',
  };

  return option;
}
